import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { PitchTeamData } from "../../../components/Models/PitchTeamData";

interface UseGetPitchTeamMembersProps {
  id: string;
  enabled?: boolean;
}

interface PitchTeamResponse {
  teamMembers: PitchTeamData[];
}

export function useGetPitchTeamMembers({
  id,
  enabled = true,
}: UseGetPitchTeamMembersProps) {
  return useQuery({
    enabled,
    queryKey: ["pitch-team-members", id],
    queryFn: async () => {
      return axiosInstance<PitchTeamResponse>(
        getAPIURL(`/Pitch/team-members-by-pitch-id/${id}`)
      ).then((response) => response.data);
    },
    retry: (failureCount, error: any) => {
      const status = error?.response?.status;
      // Do not retry for client errors
      return status !== 400 && failureCount < 3;
    },
  });
}
